import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reset",
  "use": "icon-reset-usage",
  "viewBox": "0 0 13 14",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 14\" id=\"icon-reset\"><path d=\"M11.3 9a5.356 5.356 0 0 0-2.967-6.967A5.354 5.354 0 0 0 1.367 5m2.966 0H1V1.667M9.56 11.247h-.008M1.041 7.667h-.007M2.087 10.227h-.008M4.267 11.913H4.26M7 12.293h-.007\" stroke=\"#7D69C5\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol